import React, { useState, useEffect } from 'react';

const Body = () => {
    // Simple state to simulate sequential loading if desired, 
    // but for now we'll render statically for instant view or use simple CSS animations
    
    return (
        <main className="terminal-body">
            
            {/* Skills Section */}
            <div className="terminal-section">
                <div className="terminal-comment"># --- SKILLS ---</div>
                <div className="command-line">
                    <span className="prompt">kumara@portfolio:~$</span>
                    <span className="command">cat skills.json</span>
                </div>
                <div className="output">
                    {`{`}
                    <div style={{ paddingLeft: '20px' }}>
                        <span className="json-key">"frontend_libraries":</span> <span className="json-string">["React", "Bootstrap"]</span>,
                    </div>
                    <div style={{ paddingLeft: '20px' }}>
                        <span className="json-key">"backend_framework":</span> <span className="json-string">["Node.js", "Express"]</span>,
                    </div>
                    <div style={{ paddingLeft: '20px' }}>
                        <span className="json-key">"languages":</span> <span className="json-string">["C++", "Python", "Javascript"]</span>,
                    </div>
                    <div style={{ paddingLeft: '20px' }}>
                        <span className="json-key">"databases":</span> <span className="json-string">["MySQL", "MongoDB"]</span>,
                    </div>
                    <div style={{ paddingLeft: '20px' }}>
                        <span className="json-key">"devops":</span> <span className="json-string">["Git", "Github", "Github Actions", "Docker"]</span>,
                    </div>
                    <div style={{ paddingLeft: '20px' }}>
                        <span className="json-key">"cloud":</span> <span className="json-string">["AWS"]</span>
                    </div>
                    {`}`}
                </div>
            </div>

            {/* Projects Section */}
            <div className="terminal-section">
                <div className="terminal-comment"># --- PROJECTS ---</div>
                <div className="command-line">
                    <span className="prompt">kumara@portfolio:~$</span>
                    <span className="command">./list_projects.sh</span>
                </div>
                <div className="output">
                    <div style={{ marginBottom: '20px' }}>
                        <div className="folder">InvTrack/</div>
                        <div style={{ paddingLeft: '15px', color: '#ccc' }}>
                            <p style={{ margin: '5px 0' }}>It is a role-based Inventory Management System using Node.js and MySQL, implementing a full organizational hierarchy with IAM-style access control for Owners, Admins, and Members.</p>
                            <p style={{ margin: '5px 0' }}>Features: Secure multi-team collaboration, inventory CRUD operations, stock threshold alerts, and real-time quantity updates.</p>
                            <span className="json-key">Repository:</span> <a href="https://github.com/KumarAyush204/IMS-IAM" className="json-string">[Github]</a>
                        </div>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <div className="folder">Talk Bridge/</div>
                        <div style={{ paddingLeft: '15px', color: '#ccc' }}>
                            <p style={{ margin: '5px 0' }}>A real-time video communication platform that provides live multilingual translation using Flask and Socket.io.</p>
                            <p style={{ margin: '5px 0' }}>Features: Synchronized audio/text streams, Google Speech-to-Text integration, dynamic caption translation, low-latency communication.</p>
                            <span className="json-key">Repository:</span> <a href="https://github.com/KumarAyush204/Talk-Bridge" className="json-string">[Github]</a>
                        </div>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <div className="folder">Eventify/</div>
                        <div style={{ paddingLeft: '15px', color: '#ccc' }}>
                            <p style={{ margin: '5px 0' }}>An event management platform enabling venue booking and property management with AI-powered chatbot integration.</p>
                            <p style={{ margin: '5px 0' }}>Features: Natural language queries for venues, automated report generation for bookings and venue performance.</p>
                            <span className="json-key">Repository:</span> <a href="https://github.com/KumarAyush204/Eventify" className="json-string">[Github]</a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Certifications Section */}
            <div className="terminal-section">
                <div className="terminal-comment"># --- CERTIFICATIONS ---</div>
                <div className="command-line">
                    <span className="prompt">kumara@portfolio:~$</span>
                    <span className="command">ls -la ./certifications/</span>
                </div>
                <div className="output">
                    <div className="file-list">
                        <div className="cert-item">
                            <span className="permissions">drwxr-xr-x</span> <span className="owner">aws</span> <span className="size">4096</span> <span className="date">Jan 01</span> <span className="file">
                                 AWS_Cloud_Foundations <a href="https://www.credly.com/badges/9c3b210f-4ba7-465a-8cde-fc15907fa1d5/public_url" className="bg-green">[Verify]</a>
                            </span>
                        </div>
                        <div className="cert-item">
                            <span className="permissions">drwxr-xr-x</span> <span className="owner">docker</span> <span className="size">4096</span> <span className="date">Feb 15</span> <span className="file">
                                Docker_Foundations_Professional <a href="https://www.linkedin.com/learning/certificates/52aa745d6704e3f0fd75e60a401a085f9ca825a44d2835eee24ca8318447fbc7?trk=share_certificate" className="bg-green">[Verify]</a>
                            </span>
                        </div>
                        <div className="cert-item">
                            <span className="permissions">drwxr-xr-x</span> <span className="owner">github</span> <span className="size">4096</span> <span className="date">Mar 10</span> <span className="file">
                                GitHub_Actions <a href="https://www.linkedin.com/learning/certificates/e46a5f3f338b63300ec25fcd65261caf4653c139c79478d6996dd7fcab824639?trk=share_certificate" className="bg-green">[Verify]</a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* CV Section */}
            <div className="terminal-section">
                <div className="terminal-comment"># --- CV / RESUME ---</div>
                <div className="command-line">
                    <span className="prompt">kumara@portfolio:~$</span>
                    <span className="command">wget https://mysite.com/my_cv.pdf</span>
                    <span className="cursor"></span>
                </div>
                <div className="output">
                    <div>--2026-01-28 12:00:00--  https://mysite.com/my_cv.pdf</div>
                    <div>Resolving mysite.com... 127.0.0.1</div>
                    <div>Connecting to mysite.com|127.0.0.1|:443... connected.</div>
                    <div>HTTP request sent, awaiting response... 200 OK</div>
                    <div>Length: 102400 (100K) [application/pdf]</div>
                    <div>Saving to: 'my_cv.pdf'</div>
                    <br />
                    <div>
                        my_cv.pdf   100%[===================>] 100.00K  --.-KB/s    in 0.0s    
                    </div>
                    <br />
                    <div>
                        <a href="#" className="cv-btn">open my_cv.pdf</a>
                    </div>
                </div>
            </div>

        </main>
    );
};

export default Body;
